import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setInvoiceModalOpen } from "../../../store/invoice/invoiceSlice";

const mapStateToProps = (state) => {
  const {
    is_invoice_modal_open,
    invoice_data,
    selected_invoice
  } = state.invoice;
  return {
    is_invoice_modal_open: is_invoice_modal_open,
    invoice_data: invoice_data,
    selected_invoice: selected_invoice
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    setInvoiceModalOpen
  }, dispatch);

const Store = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;
